import {
  Users,
  UserCheck,
  BadgeCheck,
  MapPin,
  Star,
  BookOpen,
  Activity,
  MousePointerClick,
  Layers,
} from 'lucide-react'
import { useOverviewAnalyticsOdf } from '../hooks/useAnalyticsOdf'
import type { FiltrosReporteOdf } from '../types'
import { TEAL, AZUL, VERDE, MORADO, ROSA, AMARILLO, KpiCard } from './KpiCard'

const nf = (n: number) => n.toLocaleString('es-EC')

interface OverviewTabProps {
  filtros: FiltrosReporteOdf
}

export function OverviewTab({ filtros }: OverviewTabProps) {
  const { data, isLoading, error } = useOverviewAnalyticsOdf(filtros)

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-32">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-500" />
      </div>
    )
  }

  if (error || !data) {
    return (
      <div className="flex items-center justify-center py-32">
        <p className="text-destructive text-sm text-center max-w-md">
          No se pudo cargar el resumen. Verifique que la integración de Analytics ODF esté
          configurada y activa, e intente nuevamente.
        </p>
      </div>
    )
  }

  return (
    <div className="space-y-5">
      {/* KPIs principales */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <KpiCard
          icon={Users}
          label="Médicos totales"
          value={nf(data.medicos_totales)}
          sub="Total de médicos registrados"
          color={TEAL}
        />
        <KpiCard
          icon={UserCheck}
          label="Médicos validados"
          value={nf(data.medicos_validados)}
          sub="Médicos con identidad verificada"
          color={VERDE}
        />
        <KpiCard
          icon={BadgeCheck}
          label="Sin validar"
          value={nf(data.medicos_no_validados)}
          sub="Médicos pendientes de validación"
          color={ROSA}
        />
        <KpiCard
          icon={Star}
          label="Especialidades"
          value={nf(data.especialidades_distintas)}
          sub="Especialidades distintas registradas"
          color={MORADO}
        />
        <KpiCard
          icon={MapPin}
          label="Provincias"
          value={nf(data.provincias_distintas)}
          sub="Provincias con médicos registrados"
          color={AZUL}
        />
        <KpiCard
          icon={BookOpen}
          label="Contenidos"
          value={nf(data.contenidos_publicados)}
          sub="Contenidos publicados disponibles"
          color={AMARILLO}
        />
        <KpiCard
          icon={Activity}
          label="Accesos totales"
          value={nf(data.accesos_totales)}
          sub="Total de accesos a contenido"
          color={TEAL}
        />
        <KpiCard
          icon={MousePointerClick}
          label="Leer"
          value={nf(data.accesos_por_accion['leer'] ?? 0)}
          sub="Accesos de tipo leer"
          color={AZUL}
        />
        <KpiCard
          icon={Layers}
          label="Descargar"
          value={nf(data.accesos_por_accion['descargar'] ?? 0)}
          sub="Accesos de tipo descargar"
          color={VERDE}
        />
      </div>
    </div>
  )
}
